import React from "react";
import styled from "styled-components";
import { Button, Title } from "../../../theme/index";

const Wrapper = styled.div`
  height: 100%;
  width: 100%;
  background: #ffaf77;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 2em 0;
`;

export default function CTA({ price, formatPrice, handleSubmit }) {
  return (
    <Wrapper>
      <Title white professionsub>
        Get started on your path to renewal
      </Title>
      <Button buy cta onClick={handleSubmit}>{`Buy $${formatPrice(
        price
      )}`}</Button>
    </Wrapper>
  );
}



// WEBPACK FOOTER //
// ./src/components/screens/Course/components/CTA.jsx